var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._m(0),_c('div',{staticClass:"user-wrap"},[_c('span',[_c('i',{staticClass:"icon icon-user_name"}),_vm._v(_vm._s(_vm.userName))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-left"},[_c('a',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../images/songshuAI_logo.png"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }